import { ItemListCard } from '@app/components/blocks/card/ItemListCard'
import { useMemo } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { usePopularHousingForms } from './usePopularHousingForms'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'

export const HousingFormPagePopularHousingFormsCard = ({
  excludeIds,
}: {
  excludeIds: (string | number)[]
}) => {
  const t = useTranslations().app
  const { popularHousingForms } = usePopularHousingForms({ excludeIds })
  const [, setLocation] = useLocation()

  const items = useMemo(
    () =>
      popularHousingForms.map((housingForm) => ({
        id: housingForm.id,
        title: housingForm.title,
        subtitle: `${housingForm.followerCount} ${t.common.followers}`,
        image: housingForm.images?.[0],
        onClick: () => setLocation(pages.housingForm(housingForm.slug)),
      })),
    [popularHousingForms, setLocation, t.common.followers],
  )

  return (
    <ItemListCard
      style={{ width: '100%' }}
      title={t.housingFormPage.popularHousingFormsCard.title}
      items={items}
    />
  )
}
